import { useState, useEffect } from 'react';
import { useParams } from 'react-router';

import { Title } from '../../utils/title';
import content from '../../utils/content';
import Layout from './Layout';
import styles from './EntryDetail.module.scss';

const StaticContent = ({ slug: propSlug }) => {

  const { slug: paramSlug } = useParams();
  const slug = propSlug || paramSlug;

  const [ loading, setLoading ] = useState(false);
  const [ item, setItem ] = useState();

  useEffect(() => {

    if (!slug) return;

    setLoading(true);

    content.getStaticContent(slug)
      .then(data => {
        setLoading(false);
        setItem(data);
      })
      .catch(() => {
        setLoading(false);
        setItem(null);
      });

  }, [slug]);

  return (
    <Layout>
      <div className={styles.root}>

        {
          loading && (
            <div className={styles.loading}>
              Loading...
            </div>
          )
        }

        {
          item && (
            <>
              <Title value={item.title} />

              <div className={`${styles.content} ${styles.article}`}>
                <div dangerouslySetInnerHTML={{ __html: item.content }} />
              </div>
            </>
          )
        }

      </div>
    </Layout>
  );
};

export default StaticContent;
